export enum EVWriteBackStatus {
  NOT_INITIATED = "not_initiated",
  INITIATED = "initiated",
  QUEUED = "queued",
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  ERROR = "error",
  MANUAL_REQUIRED = "manual_required",
}

export enum DocWriteBackStatus {
  NOT_INITIATED = "not_initiated",
  INITIATED = "initiated",
  QUEUED = "queued",
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  ERROR = "error",
  MANUAL_REQUIRED = "manual_required",
}

export enum NarRpsStatus {
  NOT_INITIATED = "not_initiated",
  INITIATED = "initiated",
  QUEUED = "queued",
  IN_PROGRESS = "in_progress",
  SUCCESS = "success",
  ERROR = "error",
  MANUAL_REQUIRED = "manual_required",
}
